import api from './api';
import types from './mutation-types';

export default {
	async getCommCodes_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	setSearchInit_({ commit }) {
		commit(types.SEARCH_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setStateClear_({ commit }) {
		commit(types.STATE_CLEAR);
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.GROUPS, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	getCompMst_({ commit, state }) {
		const { searchParams, groups } = state;
		return api
			.getCompMst({ searchParams: searchParams, currentPage: groups.currentPage, pageUnit: groups.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'gridList',
						value: data !== null && data !== undefined ? data.body.resultList : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'groups',
						value: data.body.pagingInfo
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setCompMst_({ commit }, param) {
		return api
			.postCompMst(param)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'gridList',
						value: data !== null && data !== undefined ? data.body[0] : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setCompMstMasterInfo_({ commit }, { key, value }) {
		commit(types.COMP_MST_MASTER_INFO, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	// 저장
	async saveCompMst_(store, { saveParams }) {
		return api
			.postCompMst({ saveParams })
			.then(data => {
				if (data.header.code === 0) {
					return data;
				} else {
					throw new Error(data.header.message);
				}
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	getUserName_({ commit, state }) {
		const userSearchParams = {
			cpnyScn: state.masterInfo.cpnyScn,
			cpnyCd: state.masterInfo.cpnyCd,
			crgrNm: state.masterInfo.crgrNm
		};
		return api
			.getUserName({ searchParams: userSearchParams, currentPage: state.groups.currentPage, pageUnit: state.groups.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'getUserNameList',
						value: data !== null && data !== undefined ? data.body.resultList : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
